<template>
    <div class="captcha">
        <a
            v-if="loaded"
            href="javascript:;"
            class="image-link"
            @click="refreshCaptcha"
            title="Generate a new code"
        >
            <img :src="imageUrl" alt="..." />
        </a>
        <oc-form-field
            class="mt-2"
            :target="target"
            label="Verification Code"
            v-bind="fieldAttrs"
            :inputPrepend="{component: 'i', attrs: {class: 'glyphicon glyphicon-transfer'}}"
            :displayIndication="false"
        />
    </div>
</template>

<script>
import {http_build_query} from '@utils'

export default {
    name: 'captcha',
    inject: ['form'],
    props: {
        url: String,
        width: {
            type: Number,
            default: null
        },
        height: {
            type: Number,
            default: 33
        },
        color: {
            type: String,
            default: 'b94a48'
        },
        target: {
            type: String,
            default: 'captcha'
        },
        fieldAttrs: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loaded: false,
            imageUrl: ''
        }
    },
    created() {
        this.refreshCaptcha()
    },
    methods: {
        refreshCaptcha() {
            axiosInstance.get(this.generateCaptchaURL({
                refresh: 1 // generate new every time
            })).then( response => {
                this.imageUrl = this.generateCaptchaURL()
                this.form[this.target] = ''
                this.loaded = true
            })
        },
        generateCaptchaURL(params = {}) {
            let url = this.url

            url += url.indexOf('?') === -1 ? '?' : '&'

            url += http_build_query(Object.assign({
                v: (new Date()).getTime(),
                width: this.width,
                height: this.height,
                color: this.color
            }, params))

            return url
        }
    }
}
</script>

<style scoped>
.image-link {
    border: solid 1px #ced4da;
    display: inline-block;
}
</style>
